import { useSidebarContext } from "@/components/General/Sidebar/context/sidebar.context";

export const InnerHtml = () => {
    const { innerHtml } = useSidebarContext();

    if (!innerHtml) return null;

    return <div dangerouslySetInnerHTML={{ __html: innerHtml }} />;
};
